const CHANGE_NAME = "join/CHANGE_NAME";
const CHANGE_BIRTHDAY = "join/CHANGE_BIRTHDAY";
const CHANGE_LUNAR = "join/CHANGE_LUNAR";
const CHANGE_PHONE_NO = "join/CHANGE_PHONE_NO";
const CHANGE_GENDER = "join/CHANGE_GENDER";
const CHANGE_RESIDENCE = "join/CHANGE_RESIDENCE";
const CHANGE_MEMBERSHIP = "join/CHANGE_MEMBERSHIP";
const CHANGE_PERSONAL = "join/CHANGE_PERSONAL";
const CHANGE_MARKETING = "join/CHANGE_MARKETING";
const CHANGE_THIRDPARTY = "join/CHANGE_THIRDPARTY";
const CHANGE_SMSYN = "join/CHANGE_SMSYN";
const CHANGE_KAKAOYN = "join/CHANGE_KAKAOYN";
const CHANGE_ADYN = "join/CHANGE_ADYN";
const CHANGE_PART_DIV = "join/CHANGE_PART_DIV";
const CHANGE_PART_NO = "join/CHANGE_PART_NO";
const CHANGE_RECOMMEND = "join/CHANGE_RECOMMEND";
const CHANGE_ALLYN = "join/CHANGE_ALLYN";
const CHANGE_TOTAL_ALLYN = "join/CHANGE_TOTAL_ALLYN";
const CHANGE_COMPANY_NAME = "join/CHANGE_COMPANY_NAME";
const CHANGE_COMPANY_SITE = "join/CHANGE_COMPANY_SITE";
const CHANGE_DANGUNMARKET_AD = "join/CHANGE_DANGUNMARKET_AD";
const CHANGE_BORDER_AD = "join/CHANGE_BORDER_AD";
const CHANGE_JIINSOGE = "join/CHANGE_JIINSOGE";
const CHANGE_MOONJA = "join/CHANGE_MOONJA";
const CHANGE_ETC = "join/CHANGE_ETC";
const CHANGE_DETAIL = "join/CHANGE_DETAIL";
const CHANGE_JOIN_GB = "join/CHANGE_JOIN_GB";  //가입경로 
const CHANGE_BTV = "join/CHANGE_BTV";
const CHANGE_EMART = "join/CHANGE_EMART";
const CHANGE_INOUTGB = "join/CHANGE_INOUTGB";
const CHANGE_TELECOMPANY = "join/CHANGE_TELECOMPANY";
const INCREMENT_CERTIFISTEP = "join/CHANGE_CERTIFISTEP";
const CHANGE_CERTIFICATION_ID = "join/CHANGE_CERTIFICATION_ID";
const CHANGE_PHONE_VALID = "join/CHANGE_PHONE_VALID";
const CHANGE_CERT_INPUT = "join/CHANGE_CERT_INPUT";
const CHANGE_SELFCERTIFICATION = "join/CHANGE_SELFCERTIFICATION";

const CHANGE_JEONMOONALL = "join/CHANGE_JEONMOONALL";
const CHANGE_JEONMOON1 = "join/CHANGE_JEONMOON1";
const CHANGE_JEONMOON2 = "join/CHANGE_JEONMOON2";
const CHANGE_JEONMOON3 = "join/CHANGE_JEONMOON3";
const CHANGE_JEONMOON4 = "join/CHANGE_JEONMOON4";


export const changeJeonMoonAll = (chk) => ({
  type: CHANGE_JEONMOONALL,
  chk,
});

export const changeJeonMoon1 = (chk) => ({
  type: CHANGE_JEONMOON1,
  chk,
});

export const changeJeonMoon2 = (chk) => ({
  type: CHANGE_JEONMOON2,
  chk,
});

export const changeJeonMoon3 = (chk) => ({
  type: CHANGE_JEONMOON3,
  chk,
});

export const changeJeonMoon4 = (chk) => ({
  type: CHANGE_JEONMOON4,
  chk,
});


export const changeSelfCertification = (valid) => ({
  type: CHANGE_SELFCERTIFICATION,
  valid,
});


export const changeCertiInput = (id) => ({
  type: CHANGE_CERT_INPUT,
  id,
});


export const changePhoneValid = (isValid) => ({
  type: CHANGE_PHONE_VALID,
  isValid,
});

export const changeCertificationID = (id) => ({
  type: CHANGE_CERTIFICATION_ID,
  id,
});

export const changeInOutGb = (inOutGb) => ({
  type: CHANGE_INOUTGB,
  inOutGb,
});

export const chanTeleCompany = (TeleCompany) => ({
  type: CHANGE_TELECOMPANY,
  TeleCompany,
});

export const incrementCertifistep = () => ({
  type: INCREMENT_CERTIFISTEP
});


export const changeJoinGb = (joinGb) => ({
  type: CHANGE_JOIN_GB,
  joinGb,
});


export const changeDangunMarketAd = (DangunMarketAd) => ({
  type: CHANGE_DANGUNMARKET_AD,
  DangunMarketAd,
});

export const changeBorderAd = (borderAd) => ({
  type: CHANGE_BORDER_AD,
  borderAd,
});


export const changeJiinSoge = (jiinSoge) => ({
  type: CHANGE_JIINSOGE,
  jiinSoge,
});


export const changeMoonja = (moonja) => ({
  type: CHANGE_MOONJA,
  moonja,
});

export const changeBtv = (btv) => ({
  type: CHANGE_BTV,
  btv,
});


export const changeEmart = (emart) => ({
  type: CHANGE_EMART,
  emart,
});



export const changeEtc = (etc) => ({
  type: CHANGE_ETC,
  etc,
});

export const changeEtcDetail = (etcDetail) => ({
  type: CHANGE_DETAIL,
  etcDetail,
});

export const changeName = (name) => ({
  type: CHANGE_NAME,
  name,
});
export const changeBirthday = (birthday) => ({
  type: CHANGE_BIRTHDAY,
  birthday,
});
export const changeLunar = (lunar) => ({
  type: CHANGE_LUNAR,
  lunar,
});
export const changePhone = (phone) => ({
  type: CHANGE_PHONE_NO,
  phone,
});

export const changeGender = (gender) => ({
  type: CHANGE_GENDER,
  gender,
});
export const changeResidence = (residence) => ({
  type: CHANGE_RESIDENCE,
  residence,
});
export const changeRecommend = (recommend) => ({
  type: CHANGE_RECOMMEND,
  recommend,
});
export const changeMemberShip = (memberShip) => ({
  type: CHANGE_MEMBERSHIP,
  memberShip,
});
export const changePersonal = (personal) => ({
  type: CHANGE_PERSONAL,
  personal,
});
export const changeMarketing = (marketing) => ({
  type: CHANGE_MARKETING,
  marketing,
});
export const changeThirdParty = (thirdParty) => ({
  type: CHANGE_THIRDPARTY,
  thirdParty,
});
export const changeSmsYn = (smsYn) => ({
  type: CHANGE_SMSYN,
  smsYn,
});
export const changeKakaoYn = (kakaoYn) => ({
  type: CHANGE_KAKAOYN,
  kakaoYn,
});
export const changeAdYn = (adYn) => ({
  type: CHANGE_ADYN,
  adYn,
});

export const changePartDiv = (partDiv) => ({
  type: CHANGE_PART_DIV,
  partDiv,
});
export const changePartNo = (partNo) => ({
  type: CHANGE_PART_NO,
  partNo,
});
export const changeTotalAllYn = (totalAllYn) => ({
  type: CHANGE_TOTAL_ALLYN,
  totalAllYn,
});
export const changeAllYn = (allYn) => ({
  type: CHANGE_ALLYN,
  allYn,
});
export const changeCompanyName = (companyName) => ({
  type: CHANGE_COMPANY_NAME,
  companyName,
});
export const changeCompanySite = (companySite) => ({
  type: CHANGE_COMPANY_SITE,
  companySite,
});

const initialState = {
  name: "",
  birthday: "",
  lunar: "1",
  phone: "",
  gender: "2",
  residence: "",
  recommend: "",
  totalAllYn: false,
  memberShip: false,
  personal: false,
  marketing: false,
  thirdParty: false,
  allYn: false,
  smsYn: false,
  kakaoYn: false,
  adYn: false,
  partDiv: "",
  partNo: "",
  companyName: "",
  companySite: "",
  
  /*가입시 행사장 방문 경로 항목 추가 20221118 */
  DangunMarketAd : false,
  AptBoardAd : false,
  JiinSoge : false,
  Moonja : false,
  Etc : false, 
  EtcDetail : "",
 /*가입시 행사장 방문 경로 항목 추가 20230830 */
  Btv : false,
  Emart : false,
  
  /*가입경로 url  WebPos/public/crm/join/T0001(A,B,C.....)  매장코드 6번째 자리를 가입경로로 지정 하기로 함*/  
  JoinGb : "",

  /*실명인증 단계 
  //0단계 초기화 (인증번호 보내기, text , 입력 확인버튼 비활성화)
  //1단계 값들이 다 들어간 상태에서 문자 전송이 가능한 상태  (인증번호 보내기 버튼만 활성화 )
  //2단계 문자전송을 누르고 대기순간부터 인증번호 입력 확인 전까지 상태 (text 입력버튼 활성화)
  //3단계 인증번호를 입력 후 확인이 완료된 상태 (인증번호 버튼, text 입력 확인 버튼 visible = false )
  */
  SelfCertiStep : 0 ,
  InOutGb : "1",    //내국인  1 외국인 2 
  TeleCompanyCode : "01",   //skt 01 kt 02 lg 03 알뜰폰 skt 04 kt 05 lg 06
  CertificatoinId : "",  // 실명인증 아이디 
  phoneValid : false ,
  CertiInput : "",
  SelfCertification : false ,
  JeonMoonAll : false ,
  JeonMoon1 : false ,
  JeonMoon2 : false ,
  JeonMoon3 : false ,
  JeonMoon4 : false ,

};

export default function join(state = initialState, action) {
  let allYnValue;
  let totalAllYnValue;
  
  switch (action.type) {
    case CHANGE_JOIN_GB:
      return { ...state, JoinGb: action.joinGb };
    case CHANGE_DANGUNMARKET_AD:
      return { ...state
        ,AptBoardAd : false
        ,JiinSoge : false
        ,Moonja : false
        ,Etc : false
        ,EtcDetail : ""
        ,Btv : false
        ,Emart : false
        ,DangunMarketAd: !state.DangunMarketAd
       };
    case CHANGE_BORDER_AD:
      return { ...state, 
        DangunMarketAd : false,
        //aptBoardAd : false,
        JiinSoge : false,
        Moonja : false,
        Etc : false, 
        Btv : false,
        Emart : false,
        EtcDetail : "",
        AptBoardAd: !state.AptBoardAd };
    case CHANGE_JIINSOGE:
      return { ...state,
        DangunMarketAd : false,
        AptBoardAd : false,
        //JiinSoge : false,
        Moonja : false,
        Etc : false, 
        Btv : false,
        Emart : false,
        EtcDetail : "",
        JiinSoge: !state.JiinSoge };
    case CHANGE_MOONJA:
      return { ...state,
        DangunMarketAd : false,
        AptBoardAd : false,
        JiinSoge : false,
       // moonja : false,
        Etc : false, 
        Btv : false,
        Emart : false,
        EtcDetail : "",
        Moonja: !state.Moonja };
    case CHANGE_ETC:
      return { ...state, 
        DangunMarketAd : false,
        AptBoardAd : false,
        JiinSoge : false,
        Moonja : false,
        //etc : false, 
        Btv : false,
        Emart : false,
        EtcDetail : "",
        Etc: !state.Etc };
    case CHANGE_BTV:
          return { ...state, 
            DangunMarketAd : false,
            AptBoardAd : false,
            JiinSoge : false,
            Moonja : false,
            etc : false, 
            Btv : !state.Btv,
            Emart : false,
            EtcDetail : "",
            Etc: false };
    case CHANGE_EMART:
              return { ...state, 
                DangunMarketAd : false,
                AptBoardAd : false,
                JiinSoge : false,
                Moonja : false,
                etc : false, 
                Btv : false,
                Emart : !state.Emart,
                EtcDetail : "",
                Etc: false };        
    case CHANGE_DETAIL:
      return { ...state, 
        DangunMarketAd : false,
        AptBoardAd : false,
        JiinSoge : false,
        Moonja : false,
        //etc : false, 
        //etcDetail : "",
        Etc: true,
        EtcDetail: action.etcDetail };
    case CHANGE_NAME:
      return { ...state, name: action.name };
    case CHANGE_BIRTHDAY:
      return { ...state, birthday: action.birthday };
    case CHANGE_LUNAR:
      return { ...state, lunar: action.lunar };
    case CHANGE_PHONE_NO:
      return { ...state, phone: action.phone };
    case CHANGE_GENDER:
      return { ...state, gender: action.gender };
    case CHANGE_RESIDENCE:
      return { ...state, residence: action.residence };
    case CHANGE_RECOMMEND:
      return { ...state, recommend: action.recommend };
    case CHANGE_MEMBERSHIP:
      if (
        state.allYn &&
        action.memberShip &&
        state.personal &&
        state.marketing &&
        state.thirdParty &&
        state.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return {
        ...state,
        memberShip: action.memberShip,
        totalAllYn: totalAllYnValue,
      };
    case CHANGE_PERSONAL:
      if (
        state.allYn &&
        state.memberShip &&
        action.personal &&
        state.marketing &&
        state.thirdParty &&
        state.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return {
        ...state,
        personal: action.personal,
        totalAllYn: totalAllYnValue,
      };
    case CHANGE_MARKETING:
      if (
        state.allYn &&
        state.memberShip &&
        state.personal &&
        action.marketing &&
        state.thirdParty &&
        state.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return {
        ...state,
        marketing: action.marketing,
        totalAllYn: totalAllYnValue,
      };
    case CHANGE_THIRDPARTY:
      if (
        state.allYn &&
        state.memberShip &&
        state.personal &&
        state.marketing &&
        action.thirdParty &&
        state.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return {
        ...state,
        thirdParty: action.thirdParty,
        totalAllYn: totalAllYnValue,
      };
    case CHANGE_ALLYN:
      if (
        action.allYn &&
        state.memberShip &&
        state.personal &&
        state.marketing &&
        state.thirdParty &&
        state.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return {
        ...state,
        allYn: action.allYn,
        kakaoYn: action.allYn,
        totalAllYn: totalAllYnValue,
        smsYn: action.allYn,
      };
    case CHANGE_SMSYN:
      if (state.kakaoYn && action.smsYn) {
        allYnValue = true;
      } else {
        allYnValue = false;
      }
      if (
        allYnValue &&
        state.memberShip &&
        state.personal &&
        state.marketing &&
        state.thirdParty &&
        state.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return {
        ...state,
        smsYn: action.smsYn,
        allYn: allYnValue,
        totalAllYn: totalAllYnValue,
      };
    case CHANGE_KAKAOYN:
      if (action.kakaoYn && state.smsYn) {
        allYnValue = true;
      } else {
        allYnValue = false;
      }
      if (
        allYnValue &&
        state.memberShip &&
        state.personal &&
        state.marketing &&
        state.thirdParty &&
        state.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return {
        ...state,
        kakaoYn: action.kakaoYn,
        allYn: allYnValue,
        totalAllYn: totalAllYnValue,
      };
    case CHANGE_ADYN:
      if (
        state.allYn &&
        state.memberShip &&
        state.personal &&
        state.marketing &&
        state.thirdParty &&
        action.adYn
      ) {
        totalAllYnValue = true;
      } else {
        totalAllYnValue = false;
      }
      return { ...state, adYn: action.adYn, totalAllYn: totalAllYnValue };
    case CHANGE_PART_DIV:
      return { ...state, partDiv: action.partDiv };
    case CHANGE_PART_NO:
      return { ...state, partNo: action.partNo };
    case CHANGE_TOTAL_ALLYN:
      return {
        ...state,
        totalAllYn: action.totalAllYn,
        allYn: action.totalAllYn,
        kakaoYn: action.totalAllYn,
        smsYn: action.totalAllYn,
        memberShip: action.totalAllYn,
        personal: action.totalAllYn,
        marketing: action.totalAllYn,
        thirdParty: action.totalAllYn,
        adYn: action.totalAllYn,
      };
    case CHANGE_COMPANY_NAME:
      return { ...state, companyName: action.companyName };
    case CHANGE_COMPANY_SITE:
      return { ...state, companySite: action.companySite };
    case CHANGE_CERTIFICATION_ID:
      return {...state,CertificatoinId : action.id };
    case CHANGE_INOUTGB:
      return {...state,InOutGb : action.inOutGb, };
    case  CHANGE_TELECOMPANY:
        return {...state, TeleCompanyCode : action.TeleCompany, };
    case INCREMENT_CERTIFISTEP:
      return {...state, SelfCertiStep : state.SelfCertiStep + 1, };
    case CHANGE_PHONE_VALID:
      return {...state, phoneValid : action.isValid, };
    case CHANGE_CERT_INPUT:
      return {...state, CertiInput : action.id, };
    case CHANGE_SELFCERTIFICATION:
      return {...state, SelfCertification : action.valid,};
    case CHANGE_JEONMOONALL :
      return {...state, JeonMoonAll : action.chk,JeonMoon1 : action.chk, JeonMoon2 : action.chk, JeonMoon3 : action.chk,JeonMoon4 : action.chk,};
    case CHANGE_JEONMOON1 :
      return {...state, JeonMoon1 : action.chk,};
    case CHANGE_JEONMOON2 :
      return {...state, JeonMoon2 : action.chk,};
    case CHANGE_JEONMOON3 :
      return {...state, JeonMoon3 : action.chk,};
    case CHANGE_JEONMOON4 :
      return {...state, JeonMoon4 : action.chk,};
    default:
      return state;
  }
}
